// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"dfb58d7c","305":"54f11dd6","637":"031be9bf","666":"2040248d","685":"65953775","698":"21445373","762":"759e451c","900":"93ad5ae8"}[chunkId] + ".chunk.js";
};